import { QuoteRequestState } from "@app/shared";
import { CommodityType } from '@app/shared/enums/commodity-type';

export interface IPlcNsplRequirement {
  iso: string;
  plc: boolean;
  plcLabel: string;
  plcLabelShort: string;
  plcLoadFactorLabel: string;
  nspl: boolean;
}

const defaultPlcLabel = 'Peak Load Contribution (PLC)';
const defaultPlcLabelShort = 'PLC';
const defaultPlcLoadFactorLabel = 'PLC Load Factor (%)';

const matrix: IPlcNsplRequirement[] = [
  {
    iso: 'ISONE',
    plc: true,
    nspl: false,
    plcLabel: 'Installed Capacity (ICAP)',
    plcLabelShort: 'ICAP',
    plcLoadFactorLabel: 'ICAP Load Factor (%)',
  },
  {
    iso: 'ERCOT',
    plc: false,
    nspl: false,
    plcLabel: defaultPlcLabel,
    plcLabelShort: defaultPlcLabelShort,
    plcLoadFactorLabel: defaultPlcLoadFactorLabel,
  },
  {
    iso: 'NYISO',
    plc: true,
    nspl: false,
    plcLabel: 'Installed Capacity (ICAP)',
    plcLabelShort: 'ICAP',
    plcLoadFactorLabel: 'ICAP Load Factor (%)',
  },
  {
    iso: 'PJM',
    plc: true,
    nspl: true,
    plcLabel: defaultPlcLabel,
    plcLabelShort: defaultPlcLabelShort,
    plcLoadFactorLabel: defaultPlcLoadFactorLabel,
  },
];

export const ResolvePlcNsplRequirement: (iso: string) => IPlcNsplRequirement = (iso: string) => {
  const plcNsplRequirement = matrix.find((x) => x.iso === iso) || {
    iso: '',
    plc: false,
    nspl: false,
    plcLabel: defaultPlcLabel,
    plcLabelShort: defaultPlcLabelShort,
    plcLoadFactorLabel: defaultPlcLoadFactorLabel,
  }

  return plcNsplRequirement;
};
